(function () {

    "use strict";

    function HModalController($scope, $compile, modalData, onSave, onHide, onDelete) {
        var self = this;
        self.modalData = angular.copy(modalData);
        self.onSave = onSave;
        self.onDelete = onDelete;
        var init = function () {

        };

        self.close = function () {
            if (onHide) {
                onHide(modalData);
            }
            $scope.$hide();
            $scope.$evalAsync();
        };

        init();
    }

    HModalController.$inject = ['$scope', '$compile', 'modalData', 'onSave', 'onHide', 'onDelete'];

    angular.module('harriApp').controller("hModalController", HModalController);

})();